var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"work-entry",attrs:{"to":'/work/' + _vm.id}},[_c('div',{staticClass:"work-thumb",style:(_vm.thumb ? {'background-image': 'url(' + _vm.thumbUrl + ')'} : null)}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d7a64d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkListEntry.vue
// module id = null
// module chunks = 